<template>
  <v-row no-gutters class="flex-nowrap">
    <v-col>
      <the-navbar-top-panel-menu
        attach="#measurementToolButton"
        :has-default-activator="false"
        v-bind="{ ...$attrs, tools: measurementTools }"
        :path="$attrs.name"
      >
        <template #[`menu.activator`]="{on: onMenu}">
          <span id="measurementToolButton">
            <table-button
              v-on="{ ...(!$attrs.isActive && { ...onMenu }), ...$attrs.onTooltip }"
              name="saveMeasurement"
              :icon="$attrs.isActive ? 'mdi-cancel' : $attrs.icon"
              fontSize="19px"
              :isActive="$attrs.isActive"
              buttonSize="small"
              @click="measurementsClick"
              :disabled="$attrs.disabled"
            />
          </span>
        </template>
      </the-navbar-top-panel-menu>
    </v-col>
    <v-col v-if="measurementGeometry">
      <the-navbar-top-panel-menu
        attach="#measurementExportButton"
        :has-default-activator="false"
        @exportToGeoJSON="exportMeasurement('geojson')"
        @exportToKML="exportMeasurement('kml')"
        @exportToSystem="openGeometryCopyDialog"
        v-bind="{ ...$attrs, tools: measurementExportTools }"
        :path="$attrs.name"
      >
        <template #[`menu.activator`]="{on: onMenu}">
          <span id="measurementExportButton">
            <table-button
              v-on="{ ...onMenu, ...$attrs.on }"
              name="saveMeasurement"
              icon="mdi-content-save"
              fontSize="19px"
              :isActive="true"
              buttonSize="small"
              :tooltip="$i18n.t('navbar.saveMeasurement')"
            />
          </span>
        </template>
      </the-navbar-top-panel-menu>
    </v-col>
    <table-buttons-copy-objects-geometry-dialog
      v-if="isCopyObjectsGeometryLoaded"
      :is-visible.sync="isCopyObjectsGeometryVisible"
      :is-loading.sync="isCopyObjectGeometryLoading"
      :dialog-props="{
        agreeText: 'dialog.agreeSave',
        titleTranslation: $i18n.t('sidebar.saveMeasurementToLayer'),
      }"
      :copy-layer-input-props="{
        subtitle: null,
        translationPath: 'dialog.layer',
      }"
      :available-layers-rules="{
        layer_scope: 'core',
        geometry_type:
          activeTool === 'measurementLength' ? ['linestring', 'multilinestring'] : ['polygon', 'multipolygon'],
      }"
      open-feature-card-editor
      :custom-geometry="measurementGeometry"
    />
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import TableButton from '@/components/TableButton';
import TheNavbarTopPanelMenu from '@/components/TheNavbarTopPanelMenu';

export default {
  name: 'TheNavbarToolsMeasurements',
  components: {
    TableButton,
    TheNavbarTopPanelMenu,
    TableButtonsCopyObjectsGeometryDialog: () => import('@/components/TableButtonsCopyObjectsGeometryDialog'),
  },
  data: () => ({
    isCopyObjectsGeometryLoaded: false,
    isCopyObjectsGeometryVisible: false,
    isCopyObjectGeometryLoading: false,
    measurementTools: [
      {
        name: 'measurementArea',
        hasDivider: false,
        hasCustomAction: true,
      },
      {
        name: 'measurementLength',
        hasDivider: false,
        hasCustomAction: true,
      },
      {
        name: 'measurementRadius',
        hasDivider: false,
        hasCustomAction: true,
      },
    ],
    measurementExportTools: [
      {
        name: 'exportToGeoJSON',
        hasDivider: false,
        hasCustomAction: true,
      },
      {
        name: 'exportToKML',
        hasDivider: false,
        hasCustomAction: true,
      },
      {
        name: 'exportToSystem',
        hasDivider: false,
        hasCustomAction: true,
      },
    ],
  }),
  computed: {
    measurementGeometry: get('map/measurementGeometry'),
    isMeasurementsToolActive: get('tools/toolStatus@isMeasurementsToolActive'),
    activeTool: get('tools/activeTool'),
  },
  methods: {
    openGeometryCopyDialog() {
      this.isCopyObjectsGeometryLoaded = true;
      this.isCopyObjectsGeometryVisible = true;
    },
    exportMeasurement(type) {
      this.$root.$emit('exportMeasurement', type);
    },
    measurementsClick() {
      if (this.isMeasurementsToolActive) {
        this.$root.$emit(`${this.activeTool}-action`, false);
      }
    },
  },
};
</script>
